import { z } from 'zod';
import { permissionSchema } from '../roles.ts';
import { actorSchema } from './common.ts';

export const meResponseSchema = z.object({
  user: actorSchema,
  roles: z.array(z.string()),
  permissions: z.array(permissionSchema),
  env: z.string(),
});
export type MeResponse = z.infer<typeof meResponseSchema>;

export const listFilterSchema = z.enum(['mine', 'all']);
export const themeSchema = z.enum(['light', 'dark', 'system']);

/** Every field is optional and defaults, so `{}` parses to the full default preferences. */
export const preferencesSchema = z.strictObject({
  defaultListFilter: listFilterSchema.default('mine'),
  pageSize: z.number().int().min(1).max(100).default(25),
  theme: themeSchema.default('system'),
});
export type Preferences = z.infer<typeof preferencesSchema>;
